import { apiClient } from './client';
import { cosmeticSelectionSchema, cosmeticsCatalogSchema } from './cosmetics-contract';

export const cosmeticsApi = {
  async list() {
    return cosmeticsCatalogSchema.parse(await apiClient.cosmetics.list());
  },
  async equip(kind: 'avatar' | 'frame', cosmeticId: string | null) {
    return cosmeticSelectionSchema.parse(await apiClient.cosmetics.equip({ kind, cosmeticId }));
  },
};
